import { reqCompanyInfo } from '@/routes/Apply/services';
import { TABLE_STATUS } from '../config';
import {
  getAllIncomeList,
  getIncomeAuditList,
  getIncomeCategory,
  getIncomeCategorySelectValue,
  getIncomeConfig,
  getIncomeData,
} from '../services';

export default {
  namespace: 'income',
  state: {
    // 收入类型列表
    incomeCategoryData: {
      data: [],
      pageNum: 0,
      pageSize: 10,
      total: 0,
      size: 10,
    },
    // 收入登记列表
    incomeData: {
      data: [],
      pageNum: 0,
      pageSize: 10,
      total: 0,
      size: 10,
    },
    incomeCompleteData: {
      data: [],
      pageNum: 0,
      pageSize: 10,
      total: 0,
      size: 10,
    },
    // 收入待审批列表
    incomeAuditPendingData: {
      data: [],
      pageNum: 0,
      pageSize: 10,
      total: 0,
      size: 10,
    },
    // 收入审批完成列表
    incomeAuditCompleteData: {
      data: [],
      pageNum: 0,
      pageSize: 10,
      total: 0,
      size: 10,
    },
    // 收入登记单据查询（单位维度）
    incomeAllData: {
      data: [],
      pageNum: 0,
      pageSize: 10,
      total: 0,
      size: 10,
    },
    // 当前机构数据
    orgData: {},
    // 收入所需的配置项
    incomeConfig: [],
    // 分类下拉数据（所有）
    allCategoryData: [],
    // 分类下拉数据(启用)
    availableCategoryData: [],
  },
  effects: {
    // 登记类型列表
    *getCategoryList({ payload }, { call, put }) {
      const res = yield call(getIncomeCategory, payload);
      yield put({
        type: 'update',
        payload: {
          incomeCategoryData: res?.result || {},
        },
      });
      return res;
    },
    // 登记列表(未完成)
    *getIncomeList({ payload }, { call, put }) {
      const res = yield call(getIncomeData, {
        ...payload,
        tableStatus: 1,
      });
      yield put({
        type: 'update',
        payload: {
          incomeData: res?.result || {},
        },
      });
      return res;
    },
    // 登记列表(已完成)
    *getIncomeCompleteList({ payload }, { call, put }) {
      const res = yield call(getIncomeData, {
        ...payload,
        tableStatus: 2,
      });
      yield put({
        type: 'update',
        payload: {
          incomeCompleteData: res?.result || {},
        },
      });
      return res;
    },
    // 登记列表
    *getIncomeAllList({ payload }, { call, put }) {
      const res = yield call(getAllIncomeList, payload);
      yield put({
        type: 'update',
        payload: {
          incomeAllData: res?.result || {},
        },
      });
      return res;
    },
    // 审批列表
    *getIncomeAuditList({ payload }, { call, put }) {
      const res = yield call(getIncomeAuditList, payload);
      const { tableStatus } = payload;
      if (Number(tableStatus) === TABLE_STATUS.pending) {
        yield put({
          type: 'update',
          payload: {
            incomeAuditPendingData: res?.result || {},
          },
        });
      } else if (Number(tableStatus) === TABLE_STATUS.complete) {
        yield put({
          type: 'update',
          payload: {
            incomeAuditCompleteData: res?.result || {},
          },
        });
      }
      return res;
    },
    // 单位部门列表
    *getDepartmentList({ payload }, { call, put }) {
      const result = yield call(reqCompanyInfo, payload);
      const departmentList =
        result?.departmentList?.map(i => ({
          ...i,
          fullName: `${result.orgName}${i.deptId === -1 ? '' : '-' + i.deptName}`,
        })) || [];
      yield put({
        type: 'update',
        payload: {
          orgData: result || {},
          departmentList,
        },
      });
      return result;
    },
    // 全量配置项
    *getIncomeConfig({ payload }, { call, put }) {
      const res = yield call(getIncomeConfig, payload);
      yield put({
        type: 'update',
        payload: {
          incomeConfig: res?.result || {},
        },
      });
      return res;
    },
    *getAllCategory({ payload }, { call, put }) {
      const res = yield call(getIncomeCategorySelectValue, 0);
      yield put({
        type: 'update',
        payload: {
          allCategoryData: res?.result || [],
        },
      });
      return res;
    },
    *getAvailableCategory({ payload }, { call, put }) {
      const res = yield call(getIncomeCategorySelectValue, 1);
      yield put({
        type: 'update',
        payload: {
          availableCategoryData: res?.result || [],
        },
      });
      return res;
    },
  },
  reducers: {
    update(state, { payload }) {
      return {
        ...state,
        ...payload,
      };
    },
  },
};
